/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './FilterShop.scss';
import datePickerCss from '../../../../node_modules/react-datepicker/dist/react-datepicker.min.css';
import BaseReactComponent from '../../Util/BaseReactComponent';
import baseComponent from '../../../decorators/baseComponent';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import reactMixin from 'react-mixin';

@baseComponent(datePickerCss)
@baseComponent(styles) @reactMixin.decorate(LinkedStateMixin)
class FilterShop extends BaseReactComponent {

  constructor(props) {
    super(props);

    this.state = {};
    this.state.url = '';
    this.state.country = 'BELGIUM';
  }


  componentDidMount() {
    this.updateFilterShop(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.updateFilterShop(nextProps);
  }

  updateFilterShop(props) {
    let filterShop = props.filterShop;
    this.setState(filterShop);
  }

  handleUrlChange(event) {
    let currentState = JSON.parse(JSON.stringify(this.state));
    currentState.url = event.currentTarget.value;

    this.setState(currentState);

    this.props.handleFilterShopChanged(currentState);
  }

  render() {
    let self = this;
    return (
      <div className="form-group clearfix">
        <label className="col-sm-2 control-label">{self.getIntlMessage('country.' + this.state.country)}</label>

        <div className="col-sm-10">
          <input type="url" className="validate form-control" value={this.state.url} onChange={self.handleUrlChange.bind(self)}/>
        </div>
      </div>
    );
  }
}

FilterShop.PropTypes = {
  commercialOffer: React.PropTypes.object,
  saveCommercialOffer: React.PropTypes.func,
  handleFilterShopChanged: React.PropTypes.func
};

export default FilterShop;



// WEBPACK FOOTER //
// /src/components/FilterShops/FilterShop/FilterShop.js